// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { trackSignup } from "../lib/tracking";

export default function AuthCallback() {
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const { setUser } = useAuth();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const session_id = params.get("session_id");
        if (!session_id) {
            navigate("/");
            return;
        }
        (async () => {
            try {
                const referral_code = (localStorage.getItem("flex_ref_code") || "").toUpperCase();
                const franchise_code = (localStorage.getItem("flex_fr_code") || "").toUpperCase();
                const { data } = await api.post("/auth/emergent/callback", {
                    session_id,
                    referral_code: referral_code || null,
                    franchise_code: franchise_code || null,
                });
                // Consume the codes so they're not reused
                if (referral_code) localStorage.removeItem("flex_ref_code");
                if (franchise_code) localStorage.removeItem("flex_fr_code");
                if (data.is_new_user) trackSignup();
                setUser(data.user);
                const pendingPlan = localStorage.getItem("flex_pending_plan");
                const dest = pendingPlan ? `/mobile?plan=${encodeURIComponent(pendingPlan)}` : "/dashboard";
                window.history.replaceState({}, "", dest);
                navigate(dest, { state: { user: data.user } });
            } catch (e) {
                console.error("Auth callback failed", e);
                navigate("/");
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center" data-testid="auth-callback-loading">
                <div className="inline-block w-8 h-8 border-2 border-zinc-200 border-t-black rounded-full animate-spin mb-4" />
                <p className="font-mono text-sm text-zinc-500">Signing you in…</p>
            </div>
        </div>
    );
}
